module.exports = __webpack_public_path__ + "img/warning-pink.29ed0a48.svg";